import "./PulseFABButton.css";
import { Link, useLocation } from "react-router-dom";
// import grandLogo from '../../assets/grand/GRAN-D-elementos-02.svg'

function PulseFabButton({ returnIfPathnameIs, imageSrc, text, backgroundColor = 'transparent', redirectTo }) {
    const { pathname } = useLocation()

    const _returnIfPathnameIs = Array.isArray(returnIfPathnameIs) ? returnIfPathnameIs : [returnIfPathnameIs]

     const shouldHide = _returnIfPathnameIs.some(path => {
        if (!path) return false
        // match exacto O que el pathname sea un subpath (ej: /grand/capacitaciones/123)
        return pathname === path || pathname.startsWith(`${path}/`)
    })

    if (shouldHide) return null

    return (
        <div className="pulseFabButton-container"
            style={{
                backgroundColor
            }}>
            <Link
                className="pulseFabButton-button"
                to={redirectTo}
                target="_blank"

            >
                {imageSrc && <img src={imageSrc} alt='GranD' />}
                {text && <p className="pulseFabButton--text">{text}</p>}
            </Link>
        </div>
    );
}

export default PulseFabButton;